import React, { createContext, useReducer } from 'react';
import { appReducer } from './appReducer';

export const AppContext = createContext();

const AppContextProvider = (props) => {
  const LoadSavedData = () => {
    let login = localStorage.getItem("ScoreCardUserLoginTime");
    if (!login) return null;
  
    let loginTime = parseInt(login);
    var date = new Date();
    var currentTime = date.getTime();
  
    if ((currentTime - loginTime) > 36000000) return null;  // 10 hours = 10 * 60 * 60 * 1000
  
    var savedData = localStorage.getItem("ScoreCardUser");
    if (savedData) {
      return JSON.parse(savedData);        
    }
    return null;
  };

  const savedData = LoadSavedData();  
  const initData = { 
    CurrentUser: savedData ? savedData.CurrentUser : null,
    QuickSightUrl: null,
  };

  const [appStore, dispatch] = useReducer(appReducer, [], () => {
     return initData;
  });
  
  return (
    <AppContext.Provider value={{ ...appStore, dispatch }}>
      {props.children}
    </AppContext.Provider>
  );
}

export default AppContextProvider;